export const SPRITE_VIDEO_FRAME_WIDTH = 416;
export const SPRITE_VIDEO_FRAME_HEIGHT = 544;
export const STANDALONE_VIDEO_FRAME_AREA = SPRITE_VIDEO_FRAME_WIDTH * SPRITE_VIDEO_FRAME_HEIGHT;
export const STANDALONE_VIDEO_MIN_RATIO = 9 / 16;
export const STANDALONE_VIDEO_MAX_RATIO = 21 / 9;
export const STANDALONE_VIDEO_GRID = 32;
export const STANDALONE_VIDEO_MIN_SIDE = 256;
export const STANDALONE_VIDEO_MAX_SIDE = 2048;
export const STANDALONE_VIDEO_MAX_PIXELS = 768 * 1344;

const HD_EDGE_SCALE = 1.5;

const snapSide = (value) => {
  const snapped = Math.round(value / STANDALONE_VIDEO_GRID) * STANDALONE_VIDEO_GRID;
  return Math.min(
    STANDALONE_VIDEO_MAX_SIDE,
    Math.max(STANDALONE_VIDEO_MIN_SIDE, snapped),
  );
};

const hdSide = (side) => snapSide(side * HD_EDGE_SCALE);

export const isStandaloneVideoFrame = (width, height, { hd = false } = {}) => {
  const w = hd ? hdSide(width) : width;
  const h = hd ? hdSide(height) : height;
  if (!Number.isInteger(w) || !Number.isInteger(h)) return false;
  if (w % STANDALONE_VIDEO_GRID !== 0 || h % STANDALONE_VIDEO_GRID !== 0) return false;
  if (w < STANDALONE_VIDEO_MIN_SIDE || h < STANDALONE_VIDEO_MIN_SIDE) return false;
  if (w > STANDALONE_VIDEO_MAX_SIDE || h > STANDALONE_VIDEO_MAX_SIDE) return false;
  if (w * h > STANDALONE_VIDEO_MAX_PIXELS) return false;
  const ratio = w / h;
  return ratio >= STANDALONE_VIDEO_MIN_RATIO && ratio <= STANDALONE_VIDEO_MAX_RATIO;
};

export const fitStandaloneVideoFrame = (width, height) => {
  const rawW = Number(width);
  const rawH = Number(height);
  const ratioIn = Number.isFinite(rawW) && Number.isFinite(rawH) && rawW > 0 && rawH > 0
    ? rawW / rawH
    : SPRITE_VIDEO_FRAME_WIDTH / SPRITE_VIDEO_FRAME_HEIGHT;
  const ratio = Math.min(STANDALONE_VIDEO_MAX_RATIO, Math.max(STANDALONE_VIDEO_MIN_RATIO, ratioIn));
  const targetW = Math.sqrt(STANDALONE_VIDEO_FRAME_AREA * ratio);
  const targetH = Math.sqrt(STANDALONE_VIDEO_FRAME_AREA / ratio);
  const baseW = snapSide(targetW);
  const baseH = snapSide(targetH);
  let best = null;
  for (let dw = -2; dw <= 2; dw += 1) {
    for (let dh = -2; dh <= 2; dh += 1) {
      const nextW = baseW + dw * STANDALONE_VIDEO_GRID;
      const nextH = baseH + dh * STANDALONE_VIDEO_GRID;
      if (!isStandaloneVideoFrame(nextW, nextH)) continue;
      if (!isStandaloneVideoFrame(nextW, nextH, { hd: true })) continue;
      const score = Math.abs(nextW - targetW) + Math.abs(nextH - targetH);
      if (!best || score < best.score) best = { width: nextW, height: nextH, score };
    }
  }
  if (!best) return { width: SPRITE_VIDEO_FRAME_WIDTH, height: SPRITE_VIDEO_FRAME_HEIGHT };
  return { width: best.width, height: best.height };
};

export const resolveStandaloneVideoFrame = (width, height) => {
  const rawW = Number(width);
  const rawH = Number(height);
  if (!Number.isFinite(rawW) || !Number.isFinite(rawH) || rawW <= 0 || rawH <= 0) return null;
  return fitStandaloneVideoFrame(rawW, rawH);
};
